// 存数据
export function setLocal (key, value) {
    window.localStorage.setItem(key, JSON.stringify(value))
}
// 取数据
export function getLocal (key) {
    return JSON.parse(window.localStorage.getItem(key))
}
// 删数据
export function delLocal (key) {
    window.localStorage.removeItem(key)
}
// 全部清空
export function clearLocal () {
    window.localStorage.clear()
}

/**
 * @author xxxx
 * @description 保存cookie
 * @param {String} name 需要存储cookie的key
 * @param {String} value 需要存储cookie的value
 * @param {Number} timer 默认存储多少天
 */
export function setCookie (name, value, timer = 1) {
    var Days = timer; //默认将被保存 1 天
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}

/**
 * @author xxxx
 * @description 获取cookie
 * @param {String} name 需要获取cookie的key
 */
export function getCookie (name) {
    var arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
    if (arr != null) {
        return unescape(arr[2])
    } else {
        return null
    }
}

/**
 * @author xxxx
 * @description 删除cookie
 * @param {String} name 需要删除cookie的key
 */
export function clearCookie (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}





// WEBPACK FOOTER //
// ./src/utils/storage.js